import LinearProgress from "@material-ui/core/LinearProgress";
import styled from "styled-components";

export const Root = styled(LinearProgress)`
  ${({ theme }) => `
    margin: ${theme.spacing(1, 0, 0.5)};
    height: 12px;
  `}
`;
